import { ReactNode } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SubscribeForm from '@/components/feature/SubscribeForm';
import BackToTop from '@/components/feature/BackToTop';

export default function SiteLayout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">{children}</main>
      <SubscribeForm />
      <SiteFooter />
      <BackToTop />
    </div>
  );
}